// Catálogo de Provincias y Municipios de República Dominicana
// Fuente: Alanube (https://developer.alanube.co/reference/catálogo-de-provincias-y-municipios)
// Cada provincia: { codigo, nombre, municipios: [
// { codigo, nombre }] }

export const PROVINCIAS = [
  {
    codigo: "010000", nombre: "DISTRITO NACIONAL", municipios: [
      { codigo: "010100", nombre: "SANTO DOMINGO DE GUZMÁN" },
      { codigo: "010101", nombre: "SANTO DOMINGO DE GUZMÁN (D. M.)." },
    ]
  },
  {
    codigo: "020000", nombre: "AZUA", municipios: [
      { "codigo": "020100", "nombre": "MUNICIPIO AZUA" },
      { "codigo": "020101", "nombre": "AZUA (D. M.)" },
      { "codigo": "020102", "nombre": "BARRO ARRIBA (D. M.)" },
      { "codigo": "020103", "nombre": "LAS BARÍAS-LA ESTANCIA (D. M.)" },
      { "codigo": "020104", "nombre": "LOS JOVILLOS (D. M.)" },
      { "codigo": "020105", "nombre": "PUERTO VIEJO (D. M.)" },
      { "codigo": "020106", "nombre": "BARRERAS (D. M.)" },
      { "codigo": "020107", "nombre": "DOÑA EMMA BALAGUER VIUDA VALLEJO (D. M.)" },
      { "codigo": "020108", "nombre": "CLAVELLINA (D. M.)" },
      { "codigo": "020109", "nombre": "LAS LOMAS (D. M.)" },
      { "codigo": "020200", "nombre": "MUNICIPIO LAS CHARCAS" },
      { "codigo": "020201", "nombre": "LAS CHARCAS (D. M.)" },
      { "codigo": "020202", "nombre": "PALMAR DE OCOA (D. M.)" },
      { "codigo": "020300", "nombre": "MUNICIPIO LAS YAYAS DE VIAJAMA" },
      { "codigo": "020301", "nombre": "LAS YAYAS DE VIAJAMA (D. M.)" },
      { "codigo": "020302", "nombre": "VILLARPANDO (D. M.)" },
      { "codigo": "020303", "nombre": "HATO NUEVO CORTÉS (D. M.)" },
      { "codigo": "020400", "nombre": "MUNICIPIO PADRE LAS CASAS" },
      { "codigo": "020401", "nombre": "PADRE LAS CASAS (D. M.)" },
      { "codigo": "020402", "nombre": "LAS LAGUNAS (D. M.)" },
      { "codigo": "020403", "nombre": "LA SIEMBRA (D. M.)" },
      { "codigo": "020404", "nombre": "MONTE BONITO (D. M.)" },
      { "codigo": "020405", "nombre": "LOS FRÍOS (D. M.)" },
      { "codigo": "020500", "nombre": "MUNICIPIO PERALTA" },
      { "codigo": "020501", "nombre": "PERALTA (D. M.)" },
      { "codigo": "020600", "nombre": "MUNICIPIO SABANA YEGUA" },
      { "codigo": "020601", "nombre": "SABANA YEGUA (D. M.)" },
      { "codigo": "020602", "nombre": "PROYECTO 4 (D. M.)" },
      { "codigo": "020603", "nombre": "GANADERO (D. M.)" },
      { "codigo": "020604", "nombre": "PROYECTO 2-C (D. M.)" },
      { "codigo": "020700", "nombre": "MUNICIPIO PUEBLO VIEJO" },
      { "codigo": "020701", "nombre": "PUEBLO VIEJO (D. M.)" },
      { "codigo": "020702", "nombre": "EL ROSARIO (D. M.)" },
      { "codigo": "020800", "nombre": "MUNICIPIO TÁBARA ARRIBA" },
      { "codigo": "020801", "nombre": "TÁBARA ARRIBA (D. M.)" },
      { "codigo": "020802", "nombre": "TÁBARA ABAJO (D. M.)" },
      { "codigo": "020803", "nombre": "AMIAMA GÓMEZ (D. M.)" },
      { "codigo": "020804", "nombre": "LOS TOROS (D. M.)" },
      { "codigo": "020900", "nombre": "MUNICIPIO GUAYABAL" },
      { "codigo": "020901", "nombre": "GUAYABAL (D. M.)" },
      { "codigo": "021000", "nombre": "MUNICIPIO ESTEBANÍA" },
      { "codigo": "021001", "nombre": "ESTEBANÍA (D. M.)" }
    ]
  },
  {
    codigo: "030000", nombre: "BAHORUCO", municipios: [
      { "codigo": "030001", "nombre": "MUNICIPIO NEIBA" },
      { "codigo": "030101", "nombre": "NEIBA (D. M.)" },
      { "codigo": "030102", "nombre": "EL PALMAR (D. M.)" },
      { "codigo": "030200", "nombre": "MUNICIPIO GALVÁN" },
      { "codigo": "030201", "nombre": "GALVÁN (D. M.)" },
      { "codigo": "030202", "nombre": "EL SALADO (D. M.)" },
      { "codigo": "030300", "nombre": "MUNICIPIO TAMAYO" },
      { "codigo": "030301", "nombre": "TAMAYO (D. M.)" },
      { "codigo": "030302", "nombre": "UVILLA (D. M.)" },
      { "codigo": "030303", "nombre": "SANTANA (D. M.)" },
      { "codigo": "030304", "nombre": "MONSERRATE (MONTSERRAT) (D. M.)" },
      { "codigo": "030305", "nombre": "CABEZA DE TORO (D. M.)" },
      { "codigo": "030306", "nombre": "MENA (D. M.)" },
      { "codigo": "030307", "nombre": "SANTA BÁRBARA EL 6 (D. M.)" },
      { "codigo": "030400", "nombre": "MUNICIPIO VILLA JARAGUA" },
      { "codigo": "030401", "nombre": "VILLA JARAGUA (D. M.)" },
      { "codigo": "030500", "nombre": "MUNICIPIO LOS RÍOS" },
      { "codigo": "030501", "nombre": "LOS RÍOS (D. M.)" },
      { "codigo": "030502", "nombre": "LAS CLAVELLINAS (D. M.)" }
    ]
  },
  {
    codigo: "040000", nombre: "BARAHONA", municipios: [
      [{ "codigo": "040100", "nombre": "MUNICIPIO BARAHONA" },
      { "codigo": "040101", "nombre": "BARAHONA (D. M.)" },
      { "codigo": "040102", "nombre": "EL CACHÓN (D. M.)" },
      { "codigo": "040103", "nombre": "LA GUÁZARA (D. M.)" },
      { "codigo": "040104", "nombre": "VILLA CENTRAL (D. M.)" },
      { "codigo": "040200", "nombre": "MUNICIPIO CABRAL" },
      { "codigo": "040201", "nombre": "CABRAL (D. M.)" },
      { "codigo": "040300", "nombre": "MUNICIPIO ENRIQUILLO" },
      { "codigo": "040301", "nombre": "ENRIQUILLO (D. M.)" },
      { "codigo": "040302", "nombre": "ARROYO DULCE (D. M.)" },
      { "codigo": "040400", "nombre": "MUNICIPIO PARAÍSO" },
      { "codigo": "040401", "nombre": "PARAÍSO (D. M.)" },
      { "codigo": "040402", "nombre": "LOS PATOS (D. M.)" },
      { "codigo": "040500", "nombre": "MUNICIPIO VICENTE NOBLE" },
      { "codigo": "040501", "nombre": "VICENTE NOBLE (D. M.)" },
      { "codigo": "040502", "nombre": "CANOA (D. M.)" },
      { "codigo": "040503", "nombre": "QUITA CORAZA (D. M.)" },
      { "codigo": "040504", "nombre": "FONDO NEGRO (D. M.)" },
      { "codigo": "040600", "nombre": "MUNICIPIO EL PEÑÓN" },
      { "codigo": "040601", "nombre": "EL PEÑÓN (D. M.)" },
      { "codigo": "040700", "nombre": "MUNICIPIO LA CIÉNAGA" },
      { "codigo": "040701", "nombre": "LA CIÉNAGA (D. M.)" },
      { "codigo": "040702", "nombre": "BAHORUCO (D. M.)" },
      { "codigo": "040800", "nombre": "MUNICIPIO FUNDACIÓN" },
      { "codigo": "040801", "nombre": "FUNDACIÓN (D. M.)" },
      { "codigo": "040802", "nombre": "PESCADERÍA (D. M.)" },
      { "codigo": "040900", "nombre": "MUNICIPIO LAS SALINAS" },
      { "codigo": "040901", "nombre": "LAS SALINAS (D. M.)" },
      { "codigo": "041000", "nombre": "MUNICIPIO POLO" },
      { "codigo": "041001", "nombre": "POLO (D. M.)" },
      { "codigo": "041100", "nombre": "MUNICIPIO JAQUIMEYES" },
      { "codigo": "041101", "nombre": "JAQUIMEYES (D. M.)" },
      { "codigo": "041102", "nombre": "PALO ALTO (D. M.)" }]
    ]
  },
  {
    codigo: "050000", nombre: "DAJABÓN", municipios: [
      { "codigo": "050100", "nombre": "MUNICIPIO DAJABÓN" },
      { "codigo": "050101", "nombre": "DAJABÓN (D. M.)" },
      { "codigo": "050102", "nombre": "CAÑONGO (D. M.)" },
      { "codigo": "050200", "nombre": "MUNICIPIO LOMA DE CABRERA" },
      { "codigo": "050201", "nombre": "LOMA DE CABRERA (D. M.)" },
      { "codigo": "050202", "nombre": "CAPOTILLO (D. M.)" },
      { "codigo": "050203", "nombre": "SANTIAGO DE LA CRUZ (D. M.)" },
      { "codigo": "050300", "nombre": "MUNICIPIO PARTIDO" },
      { "codigo": "050301", "nombre": "PARTIDO (D. M.)" },
      { "codigo": "050400", "nombre": "MUNICIPIO RESTAURACIÓN" },
      { "codigo": "050401", "nombre": "RESTAURACIÓN (D. M.)" },
      { "codigo": "050500", "nombre": "MUNICIPIO EL PINO" },
      { "codigo": "050501", "nombre": "EL PINO (D. M.)" },
      { "codigo": "050502", "nombre": "MANUEL BUENO (D. M.)" }
    ]
  },
  {
    codigo: "060000", nombre: "DUARTE", municipios: [
      { "codigo": "060100", "nombre": "MUNICIPIO SAN FRANCISCO DE MACORÍS" },
      { "codigo": "060101", "nombre": "SAN FRANCISCO DE MACORÍS (D. M.)" },
      { "codigo": "060102", "nombre": "LA PEÑA (D. M.)" },
      { "codigo": "060103", "nombre": "CENOVÍ (D. M.)" },
      { "codigo": "060104", "nombre": "JAYA (D. M.)" },
      { "codigo": "060105", "nombre": "PRESIDENTE DON ANTONIO GUZMÁN FERNÁNDEZ (D. M.)" },
      { "codigo": "060200", "nombre": "MUNICIPIO ARENOSO" },
      { "codigo": "060201", "nombre": "ARENOSO (D. M.)" },
      { "codigo": "060202", "nombre": "LAS COLES (D. M.)" },
      { "codigo": "060203", "nombre": "EL AGUACATE (D. M.)" },
      { "codigo": "060300", "nombre": "MUNICIPIO CASTILLO" },
      { "codigo": "060301", "nombre": "CASTILLO (D. M.)" },
      { "codigo": "060400", "nombre": "MUNICIPIO PIMENTEL" },
      { "codigo": "060401", "nombre": "PIMENTEL (D. M.)" },
      { "codigo": "060500", "nombre": "MUNICIPIO VILLA RIVA" },
      { "codigo": "060501", "nombre": "VILLA RIVA (D. M.)" },
      { "codigo": "060502", "nombre": "AGUA SANTA DEL YUNA (D. M.)" },
      { "codigo": "060503", "nombre": "CRISTO REY DE GUARAGUAO (D. M.)" },
      { "codigo": "060504", "nombre": "LAS TARANAS (D. M.)" },
      { "codigo": "060505", "nombre": "BARRAQUITO (D. M.)" },
      { "codigo": "060600", "nombre": "MUNICIPIO LAS GUÁRANAS" },
      { "codigo": "060601", "nombre": "LAS GUÁRANAS (D. M.)" },
      { "codigo": "060700", "nombre": "MUNICIPIO EUGENIO MARÍA DE HOSTOS" },
      { "codigo": "060701", "nombre": "EUGENIO MARÍA DE HOSTOS (D. M.)" },
      { "codigo": "060702", "nombre": "SABANA GRANDE (D. M.)" }
    ]
  },
  {
    codigo: "070000", nombre: "ELÍAS PIÑA", municipios: [
      { "codigo": "070100", "nombre": "MUNICIPIO COMENDADOR" },
      { "codigo": "070101", "nombre": "COMENDADOR (D. M.)" },
      { "codigo": "070102", "nombre": "SABANA LARGA (D. M.)" },
      { "codigo": "070103", "nombre": "GUAYABO (D. M.)" },
      { "codigo": "070200", "nombre": "MUNICIPIO BÁNICA" },
      { "codigo": "070201", "nombre": "BÁNICA (D. M.)" },
      { "codigo": "070202", "nombre": "SABANA CRUZ (D. M.)" },
      { "codigo": "070203", "nombre": "SABANA HIGÜERO (D. M.)" },
      { "codigo": "070300", "nombre": "MUNICIPIO EL LLANO" },
      { "codigo": "070301", "nombre": "EL LLANO (D. M.)" },
      { "codigo": "070302", "nombre": "GUANITO (D. M.)" },
      { "codigo": "070400", "nombre": "MUNICIPIO HONDO VALLE" },
      { "codigo": "070401", "nombre": "HONDO VALLE (D. M.)" },
      { "codigo": "070402", "nombre": "RANCHO DE LA GUARDIA (D. M.)" },
      { "codigo": "070500", "nombre": "MUNICIPIO PEDRO SANTANA" },
      { "codigo": "070501", "nombre": "PEDRO SANTANA (D. M.)" },
      { "codigo": "070502", "nombre": "RÍO LIMPIO (D. M.)" },
      { "codigo": "070600", "nombre": "MUNICIPIO JUAN SANTIAGO" },
      { "codigo": "070601", "nombre": "JUAN SANTIAGO (D. M.)" }
    ]
  },
  {
    codigo: "080000", nombre: "EL SEIBO", municipios: [
      { "codigo": "080100", "nombre": "MUNICIPIO EL SEIBO" },
      { "codigo": "080101", "nombre": "EL SEIBO (D. M.)" },
      { "codigo": "080102", "nombre": "PEDRO SÁNCHEZ (D. M.)" },
      { "codigo": "080103", "nombre": "SAN FRANCISCO-VICENTILLO (D. M.)" },
      { "codigo": "080104", "nombre": "SANTA LUCÍA (D. M.)" },
      { "codigo": "080200", "nombre": "MUNICIPIO MICHES" },
      { "codigo": "080201", "nombre": "MICHES (D. M.)" },
      { "codigo": "080202", "nombre": "EL CEDRO (D. M.)" },
      { "codigo": "080203", "nombre": "LA GINA (D. M.)" }
    ]
  },
  {
    codigo: "090000", nombre: "ESPAILLAT", municipios: [
      { "codigo": "090100", "nombre": "MUNICIPIO MOCA" },
      { "codigo": "090101", "nombre": "MOCA (D. M.)" },
      { "codigo": "090102", "nombre": "JOSÉ CONTRERAS (D. M.)" },
      { "codigo": "090103", "nombre": "SAN VÍCTOR (D. M.)" },
      { "codigo": "090104", "nombre": "JUAN LÓPEZ (D. M.)" },
      { "codigo": "090105", "nombre": "LAS LAGUNAS (D. M.)" },
      { "codigo": "090106", "nombre": "CANCA LA REYNA (D. M.)" },
      { "codigo": "090107", "nombre": "EL HIGÜERITO (D. M.)" },
      { "codigo": "090108", "nombre": "MONTE DE LA JAGUA (D. M.)" },
      { "codigo": "090109", "nombre": "LA ORTEGA (D. M.)" },
      { "codigo": "090200", "nombre": "MUNICIPIO CAYETANO GERMOSÉN" },
      { "codigo": "090201", "nombre": "CAYETANO GERMOSÉN (D. M.)" },
      { "codigo": "090300", "nombre": "MUNICIPIO GASPAR HERNÁNDEZ" },
      { "codigo": "090301", "nombre": "GASPAR HERNÁNDEZ (D. M.)" },
      { "codigo": "090302", "nombre": "JOBA ARRIBA (D. M.)" },
      { "codigo": "090303", "nombre": "VERAGUA (D. M.)" },
      { "codigo": "090304", "nombre": "VILLA MAGANTE (D. M.)" },
      { "codigo": "090400", "nombre": "MUNICIPIO JAMAO AL NORTE" },
      { "codigo": "090401", "nombre": "JAMAO AL NORTE (D. M.)" }
    ]
  },
  {
    codigo: "100000", nombre: "INDEPENDENCIA", municipios: [
      { "codigo": "100100", "nombre": "MUNICIPIO JIMANÍ" },
      { "codigo": "100101", "nombre": "JIMANÍ (D. M.)" },
      { "codigo": "100102", "nombre": "EL LIMÓN (D. M.)" },
      { "codigo": "100103", "nombre": "BOCA DE CACHÓN (D. M.)" },
      { "codigo": "100200", "nombre": "MUNICIPIO DUVERGÉ" },
      { "codigo": "100201", "nombre": "DUVERGÉ (D. M.)" },
      { "codigo": "100202", "nombre": "VENGAN A VER (D. M.)" },
      { "codigo": "100300", "nombre": "MUNICIPIO LA DESCUBIERTA" },
      { "codigo": "100301", "nombre": "LA DESCUBIERTA (D. M.)" },
      { "codigo": "100400", "nombre": "MUNICIPIO POSTRER RÍO" },
      { "codigo": "100401", "nombre": "POSTRER RÍO (D. M.)" },
      { "codigo": "100402", "nombre": "GUAYABAL (D. M.)" },
      { "codigo": "100500", "nombre": "MUNICIPIO CRISTÓBAL" },
      { "codigo": "100501", "nombre": "CRISTÓBAL (D. M.)" },
      { "codigo": "100502", "nombre": "BATEY 8 (D. M.)" },
      { "codigo": "100600", "nombre": "MUNICIPIO MELLA" },
      { "codigo": "100601", "nombre": "MELLA (D. M.)" },
      { "codigo": "100602", "nombre": "LA COLONIA (D. M.)" }
    ]
  },
  {
    codigo: "110000", nombre: "LA ALTAGRACIA", municipios: [
      { "codigo": "110100", "nombre": "MUNICIPIO HIGÜEY" },
      { "codigo": "110101", "nombre": "HIGÜEY (D. M.)" },
      { "codigo": "110102", "nombre": "LAS LAGUNAS DE NISIBÓN (D. M.)" },
      { "codigo": "110103", "nombre": "LA OTRA BANDA (D. M.)" },
      { "codigo": "110104", "nombre": "VERÓN PUNTA CANA (D. M.) (Incluye Bávaro)" },
      { "codigo": "110200", "nombre": "MUNICIPIO SAN RAFAEL DEL YUMA" },
      { "codigo": "110201", "nombre": "SAN RAFAEL DEL YUMA (D. M.)" },
      { "codigo": "110202", "nombre": "BOCA DE YUMA (D. M.)" },
      { "codigo": "110203", "nombre": "BAYAHÍBE (D. M.)" }
    ]
  },
  {
    codigo: "120000", nombre: "LA ROMANA", municipios: [
      { "codigo": "120100", "nombre": "MUNICIPIO LA ROMANA" },
      { "codigo": "120101", "nombre": "LA ROMANA (D. M.)" },
      { "codigo": "120102", "nombre": "CALETA (D. M.)" },
      { "codigo": "120200", "nombre": "MUNICIPIO GUAYMATE" },
      { "codigo": "120201", "nombre": "GUAYMATE (D. M.)" },
      { "codigo": "120300", "nombre": "MUNICIPIO VILLA HERMOSA" },
      { "codigo": "120301", "nombre": "VILLA HERMOSA (D. M.)" },
      { "codigo": "120302", "nombre": "CUMAYASA (D. M.)" }
    ]
  },
  {
    codigo: "130000", nombre: "LA VEGA", municipios: [
      { "codigo": "130100", "nombre": "MUNICIPIO LA VEGA" },
      { "codigo": "130101", "nombre": "LA VEGA (D. M.)" },
      { "codigo": "130102", "nombre": "RÍO VERDE ARRIBA (D. M.)" },
      { "codigo": "130103", "nombre": "EL RANCHITO (D. M.)" },
      { "codigo": "130104", "nombre": "TAVERAS (D. M.)" },
      { "codigo": "130105", "nombre": "DON JUAN RODRÍGUEZ (D. M.)" },
      { "codigo": "130200", "nombre": "MUNICIPIO CONSTANZA" },
      { "codigo": "130201", "nombre": "CONSTANZA (D. M.)" },
      { "codigo": "130202", "nombre": "TIREO (D. M.)" },
      { "codigo": "130203", "nombre": "LA SABINA (D. M.)" },
      { "codigo": "130300", "nombre": "MUNICIPIO JARABACOA" },
      { "codigo": "130301", "nombre": "JARABACOA (D. M.)" },
      { "codigo": "130302", "nombre": "BUENA VISTA (D. M.)" },
      { "codigo": "130303", "nombre": "MANABAO (D. M.)" },
      { "codigo": "130400", "nombre": "MUNICIPIO JIMA ABAJO" },
      { "codigo": "130401", "nombre": "JIMA ABAJO (D. M.)" },
      { "codigo": "130402", "nombre": "RINCÓN (D. M.)" }
    ]
  },
  {
    codigo: "140000", nombre: "MARÍA TRINIDAD SÁNCHEZ", municipios: [
      { "codigo": "140100", "nombre": "MUNICIPIO NAGUA" },
      { "codigo": "140101", "nombre": "NAGUA (D. M.)" },
      { "codigo": "140102", "nombre": "SAN JOSÉ DE MATANZAS (D. M.)" },
      { "codigo": "140103", "nombre": "LAS GORDAS (D. M.)" },
      { "codigo": "140104", "nombre": "ARROYO AL MEDIO (D. M.)" },
      { "codigo": "140200", "nombre": "MUNICIPIO CABRERA" },
      { "codigo": "140201", "nombre": "CABRERA (D. M.)" },
      { "codigo": "140202", "nombre": "ARROYO SALADO (D. M.)" },
      { "codigo": "140203", "nombre": "LA ENTRADA (D. M.)" },
      { "codigo": "140300", "nombre": "MUNICIPIO EL FACTOR" },
      { "codigo": "140301", "nombre": "EL FACTOR (D. M.)" },
      { "codigo": "140302", "nombre": "EL POZO (D. M.)" },
      { "codigo": "140400", "nombre": "MUNICIPIO RÍO SAN JUAN" },
      { "codigo": "140401", "nombre": "RÍO SAN JUAN (D. M.)" }
    ]
  },
  {
    codigo: "150000", nombre: "MONTE CRISTI", municipios: [
      { "codigo": "150100", "nombre": "MUNICIPIO MONTE CRISTI" },
      { "codigo": "150101", "nombre": "MONTE CRISTI (D. M.)" },
      { "codigo": "150200", "nombre": "MUNICIPIO CASTAÑUELAS" },
      { "codigo": "150201", "nombre": "CASTAÑUELAS (D. M.)" },
      { "codigo": "150202", "nombre": "PALO VERDE (D. M.)" },
      { "codigo": "150300", "nombre": "MUNICIPIO GUAYUBÍN" },
      { "codigo": "150301", "nombre": "GUAYUBÍN (D. M.)" },
      { "codigo": "150302", "nombre": "VILLA ELISA (D. M.)" },
      { "codigo": "150303", "nombre": "HATILLO PALMA (D. M.)" },
      { "codigo": "150304", "nombre": "CANA CHAPETÓN (D. M.)" },
      { "codigo": "150400", "nombre": "MUNICIPIO LAS MATAS DE SANTA CRUZ" },
      { "codigo": "150401", "nombre": "LAS MATAS DE SANTA CRUZ (D. M.)" },
      { "codigo": "150500", "nombre": "MUNICIPIO PEPILLO SALCEDO" },
      { "codigo": "150501", "nombre": "PEPILLO SALCEDO (MANZANILLO)" },
      { "codigo": "150502", "nombre": "SANTA MARÍA (D. M.)" },
      { "codigo": "150600", "nombre": "MUNICIPIO VILLA VÁSQUEZ" },
      { "codigo": "150601", "nombre": "VILLA VÁSQUEZ" }
    ]
  },
  {
    codigo: "160000", nombre: "PEDERNALES", municipios: [
      { "codigo": "160100", "nombre": "MUNICIPIO PEDERNALES" },
      { "codigo": "160101", "nombre": "PEDERNALES" },
      { "codigo": "160102", "nombre": "JOSÉ FRANCISCO PEÑA GÓMEZ (D. M.)" },
      { "codigo": "160200", "nombre": "MUNICIPIO OVIEDO" },
      { "codigo": "160201", "nombre": "OVIEDO" },
      { "codigo": "160202", "nombre": "JUANCHO (D. M.)" }
    ]
  },
  {
    codigo: "170000", nombre: "PERAVIA", municipios: [
      { "codigo": "170100", "nombre": "MUNICIPIO BANÍ" },
      { "codigo": "170101", "nombre": "BANÍ (D. M.)" },
      { "codigo": "170102", "nombre": "MATANZAS (D. M.)" },
      { "codigo": "170103", "nombre": "VILLA FUNDACIÓN (D. M.)" },
      { "codigo": "170104", "nombre": "SABANA BUEY (D. M.)" },
      { "codigo": "170105", "nombre": "PAYA (D. M.)" },
      { "codigo": "170106", "nombre": "VILLA SOMBRERO (D. M.)" },
      { "codigo": "170107", "nombre": "EL CARRETÓN (D. M.)" },
      { "codigo": "170108", "nombre": "CATALINA (D. M.)" },
      { "codigo": "170109", "nombre": "EL LIMONAL (D. M.)" },
      { "codigo": "170110", "nombre": "LAS BARÍAS (D. M.)" },
      { "codigo": "170200", "nombre": "MUNICIPIO NIZAO" },
      { "codigo": "170201", "nombre": "NIZAO" },
      { "codigo": "170202", "nombre": "PIZARRETE (D. M.)" },
      { "codigo": "170203", "nombre": "SANTANA (D. M.)" },
      { "codigo": "170300", "nombre": "MATANZAS" },
      { "codigo": "170301", "nombre": "MATANZAS" }
    ]
  },
  {
    codigo: "180000", nombre: "PUERTO PLATA", municipios: [
      { "codigo": "180100", "nombre": "MUNICIPIO PUERTO PLATA" },
      { "codigo": "180101", "nombre": "PUERTO PLATA (D. M.)" },
      { "codigo": "180102", "nombre": "YÁSICA ARRIBA (D. M.)" },
      { "codigo": "180103", "nombre": "MAIMÓN (D. M.)" },
      { "codigo": "180200", "nombre": "MUNICIPIO ALTAMIRA" },
      { "codigo": "180201", "nombre": "ALTAMIRA" },
      { "codigo": "180202", "nombre": "RÍO GRANDE (D. M.)" },
      { "codigo": "180300", "nombre": "MUNICIPIO GUANANICO" },
      { "codigo": "180301", "nombre": "GUANANICO" },
      { "codigo": "180400", "nombre": "MUNICIPIO IMBERT" },
      { "codigo": "180401", "nombre": "IMBERT" },
      { "codigo": "180500", "nombre": "MUNICIPIO LOS HIDALGOS" },
      { "codigo": "180501", "nombre": "LOS HIDALGOS" },
      { "codigo": "180502", "nombre": "NAVAS (D. M.)" },
      { "codigo": "180600", "nombre": "MUNICIPIO LUPERÓN" },
      { "codigo": "180601", "nombre": "LUPERÓN" },
      { "codigo": "180602", "nombre": "LA ISABELA (D. M.)" },
      { "codigo": "180603", "nombre": "BELLOSO (D. M.)" },
      { "codigo": "180604", "nombre": "EL ESTRECHO DE LUPERÓN OMAR BROSS (D. M.)" },
      { "codigo": "180700", "nombre": "MUNICIPIO SOSÚA" },
      { "codigo": "180701", "nombre": "SOSÚA" },
      { "codigo": "180702", "nombre": "CABARETE (D. M.)" },
      { "codigo": "180703", "nombre": "SABANETA DE YÁSICA (D. M.)" },
      { "codigo": "180800", "nombre": "MUNICIPIO VILLA ISABELA" },
      { "codigo": "180801", "nombre": "VILLA ISABELA" },
      { "codigo": "180802", "nombre": "ESTERO HONDO (D. M.)" },
      { "codigo": "180803", "nombre": "LA JAIBA (D. M.)" },
      { "codigo": "180804", "nombre": "GUALETE (D. M.)" },
      { "codigo": "180900", "nombre": "MUNICIPIO VILLA MONTELLANO" },
      { "codigo": "180901", "nombre": "VILLA MONTELLANO" }
    ]
  },
  {
    codigo: "190000", nombre: "HERMANAS MIRABAL", municipios: [
      { "codigo": "190100", "nombre": "MUNICIPIO SALCEDO" },
      { "codigo": "190101", "nombre": "SALCEDO" },
      { "codigo": "190102", "nombre": "JAMAO AFUERA (D. M.)" },
      { "codigo": "190200", "nombre": "MUNICIPIO TENARES" },
      { "codigo": "190201", "nombre": "TENARES" },
      { "codigo": "190202", "nombre": "BLANCO (D. M.)" },
      { "codigo": "190300", "nombre": "MUNICIPIO VILLA TAPIA" },
      { "codigo": "190301", "nombre": "VILLA TAPIA" }
    ]
  },
  {
    codigo: "200000", nombre: "SAMANÁ", municipios: [
      { "codigo": "200100", "nombre": "MUNICIPIO SAMANÁ" },
      { "codigo": "200101", "nombre": "SAMANÁ" },
      { "codigo": "200102", "nombre": "EL LIMÓN (D. M.)" },
      { "codigo": "200103", "nombre": "ARROYO BARRIL (D. M.)" },
      { "codigo": "200104", "nombre": "LAS GALERAS (D. M.)" },
      { "codigo": "200200", "nombre": "MUNICIPIO SÁNCHEZ" },
      { "codigo": "200201", "nombre": "SÁNCHEZ (D. M.)" },
      { "codigo": "200300", "nombre": "MUNICIPIO LAS TERRENAS" },
      { "codigo": "200301", "nombre": "LAS TERRENAS" }
    ]
  },
  {
    codigo: "210000", nombre: "SAN CRISTÓBAL", municipios: [
      { "codigo": "210100", "nombre": "MUNICIPIO SAN CRISTÓBAL" },
      { "codigo": "210101", "nombre": "SAN CRISTÓBAL (D. M.)" },
      { "codigo": "210102", "nombre": "HATO DAMAS (D. M.)" },
      { "codigo": "210103", "nombre": "HATILLO (D. M.)" },
      { "codigo": "210200", "nombre": "MUNICIPIO SABANA GRANDE DE PALENQUE" },
      { "codigo": "210201", "nombre": "SABANA GRANDE DE PALENQUE (D. M.)" },
      { "codigo": "210300", "nombre": "MUNICIPIO BAJOS DE HAINA" },
      { "codigo": "210301", "nombre": "BAJOS DE HAINA" },
      { "codigo": "210302", "nombre": "EL CARRIL (D. M.)" },
      { "codigo": "210303", "nombre": "QUITA SUEÑO (D. M.)" },
      { "codigo": "210400", "nombre": "MUNICIPIO CAMBITA GARABITOS" },
      { "codigo": "210401", "nombre": "CAMBITA GARABITOS" },
      { "codigo": "210402", "nombre": "CAMBITA EL PUEBLECITO (D. M.)" },
      { "codigo": "210500", "nombre": "MUNICIPIO VILLA ALTAGRACIA" },
      { "codigo": "210501", "nombre": "VILLA ALTAGRACIA" },
      { "codigo": "210502", "nombre": "SAN JOSÉ DEL PUERTO (D. M.)" },
      { "codigo": "210503", "nombre": "MEDINA (D. M.)" },
      { "codigo": "210504", "nombre": "LA CUCHILLA (D. M.)" },
      { "codigo": "210600", "nombre": "MUNICIPIO YAGUATE" },
      { "codigo": "210601", "nombre": "YAGUATE (D. M.)" },
      { "codigo": "210602", "nombre": "DOÑA ANA (D. M.)" },
      { "codigo": "210700", "nombre": "MUNICIPIO SAN GREGORIO DE NIGUA" },
      { "codigo": "210701", "nombre": "SAN GREGORIO DE NIGUA" },
      { "codigo": "210800", "nombre": "MUNICIPIO LOS CACAOS" },
      { "codigo": "210801", "nombre": "LOS CACAOS (D. M.)" }
    ]
  },
  {
    codigo: "220000", nombre: "SAN JUAN", municipios: [
      { "codigo": "220100", "nombre": "MUNICIPIO SAN JUAN" },
      { "codigo": "220101", "nombre": "SAN JUAN" },
      { "codigo": "220102", "nombre": "PEDRO CORTO (D. M.)" },
      { "codigo": "220103", "nombre": "SABANETA (D. M.)" },
      { "codigo": "220104", "nombre": "SABANA ALTA (D. M.)" },
      { "codigo": "220105", "nombre": "EL ROSARIO (D. M.)" },
      { "codigo": "220106", "nombre": "HATO DEL PADRE (D. M.)" },
      { "codigo": "220107", "nombre": "GUANITO (D. M.)" },
      { "codigo": "220108", "nombre": "LA JAGUA (D. M.)" },
      { "codigo": "220109", "nombre": "LAS MAGUANAS-HATO NUEVO (D. M.)" },
      { "codigo": "220110", "nombre": "LAS CHARCAS DE MARÍA NOVA (D. M.)" },
      { "codigo": "220111", "nombre": "LAS ZANJAS (D. M.)" },
      { "codigo": "220200", "nombre": "MUNICIPIO BOHECHÍO" },
      { "codigo": "220201", "nombre": "BOHECHÍO" },
      { "codigo": "220202", "nombre": "ARROYO CANO (D. M.)" },
      { "codigo": "220203", "nombre": "YAQUE (D. M.)" },
      { "codigo": "220300", "nombre": "MUNICIPIO EL CERCADO" },
      { "codigo": "220301", "nombre": "EL CERCADO" },
      { "codigo": "220302", "nombre": "DERRUMBADERO (D. M.)" },
      { "codigo": "220303", "nombre": "BATISTA (D. M.)" },
      { "codigo": "220400", "nombre": "MUNICIPIO JUAN DE HERRERA" },
      { "codigo": "220401", "nombre": "JUAN DE HERRERA" },
      { "codigo": "220402", "nombre": "JÍNOVA (D. M.)" },
      { "codigo": "220500", "nombre": "MUNICIPIO LAS MATAS DE FARFÁN" },
      { "codigo": "220501", "nombre": "LAS MATAS DE FARFÁN" },
      { "codigo": "220502", "nombre": "MATAYAYA (D. M.)" },
      { "codigo": "220503", "nombre": "CARRERA DE YEGUAS (D. M.)" },
      { "codigo": "220600", "nombre": "MUNICIPIO VALLEJUELO" },
      { "codigo": "220601", "nombre": "VALLEJUELO" },
      { "codigo": "220602", "nombre": "JORJILLO (D. M.)" }
    ]
  },
  {
    codigo: "230000", nombre: "SAN PEDRO DE MACORÍS", municipios: [
      { "codigo": "230100", "nombre": "MUNICIPIO SAN PEDRO DE MACORÍS" },
      { "codigo": "230101", "nombre": "SAN PEDRO DE MACORÍS" },
      { "codigo": "230200", "nombre": "MUNICIPIO LOS LLANOS" },
      { "codigo": "230201", "nombre": "LOS LLANOS" },
      { "codigo": "230202", "nombre": "EL PUERTO (D. M.)" },
      { "codigo": "230203", "nombre": "GAUTIER (D. M.)" },
      { "codigo": "230300", "nombre": "MUNICIPIO RAMÓN SANTANA" },
      { "codigo": "230301", "nombre": "RAMÓN SANTANA" },
      { "codigo": "230400", "nombre": "MUNICIPIO CONSUELO" },
      { "codigo": "230401", "nombre": "CONSUELO" },
      { "codigo": "230500", "nombre": "MUNICIPIO QUISQUEYA" },
      { "codigo": "230501", "nombre": "QUISQUEYA" },
      { "codigo": "230600", "nombre": "MUNICIPIO GUAYACANES" },
      { "codigo": "230601", "nombre": "GUAYACANES" }
    ]
  },
  {
    codigo: "240000", nombre: "SÁNCHEZ RAMÍREZ", municipios: [
      { "codigo": "240100", "nombre": "MUNICIPIO COTUÍ" },
      { "codigo": "240101", "nombre": "COTUÍ" },
      { "codigo": "240102", "nombre": "QUITA SUEÑO (D. M.)" },
      { "codigo": "240103", "nombre": "CABALLERO (D. M.)" },
      { "codigo": "240104", "nombre": "COMEDERO ARRIBA (D. M.)" },
      { "codigo": "240105", "nombre": "PLATANAL (D. M.)" },
      { "codigo": "240106", "nombre": "ZAMBRANA ABAJO" },
      { "codigo": "240200", "nombre": "MUNICIPIO CEVICOS" },
      { "codigo": "240201", "nombre": "CEVICOS" },
      { "codigo": "240202", "nombre": "LA CUEVA (D. M.)" },
      { "codigo": "240300", "nombre": "MUNICIPIO FANTINO" },
      { "codigo": "240301", "nombre": "FANTINO" },
      { "codigo": "240400", "nombre": "MUNICIPIO LA MATA" },
      { "codigo": "240401", "nombre": "LA MATA" },
      { "codigo": "240402", "nombre": "LA BIJA (D. M.)" },
      { "codigo": "240403", "nombre": "ANGELINA (D. M.)" },
      { "codigo": "240404", "nombre": "HERNANDO ALONZO (D. M.)" }
    ]
  },
  {
    codigo: "250000", nombre: "SANTIAGO", municipios: [
      { "codigo": "250100", "nombre": "MUNICIPIO SANTIAGO" },
      { "codigo": "250101", "nombre": "SANTIAGO" },
      { "codigo": "250102", "nombre": "PEDRO GARCÍA (D. M.)" },
      { "codigo": "250104", "nombre": "BAITOA (D. M.)" },
      { "codigo": "250105", "nombre": "LA CANELA (D. M.)" },
      { "codigo": "250106", "nombre": "SAN FRANCISCO DE JACAGUA (D. M.)" },
      { "codigo": "250107", "nombre": "HATO DEL YAQUE (D. M.)" },
      { "codigo": "250200", "nombre": "MUNICIPIO BISONÓ" },
      { "codigo": "250201", "nombre": "VILLA BISONÓ (NAVARRETE) (D. M.)" },
      { "codigo": "250300", "nombre": "MUNICIPIO JÁNICO" },
      { "codigo": "250301", "nombre": "JÁNICO" },
      { "codigo": "250302", "nombre": "JUNCALITO (D. M.)" },
      { "codigo": "250303", "nombre": "EL CAIMITO (D. M.)" },
      { "codigo": "250400", "nombre": "MUNICIPIO LICEY AL MEDIO" },
      { "codigo": "250401", "nombre": "LICEY AL MEDIO" },
      { "codigo": "250402", "nombre": "LAS PALOMAS (D. M.)" },
      { "codigo": "250500", "nombre": "MUNICIPIO SAN JOSÉ DE LAS MATAS" },
      { "codigo": "250501", "nombre": "SAN JOSÉ DE LAS MATAS" },
      { "codigo": "250502", "nombre": "EL RUBIO (D. M.)" },
      { "codigo": "250503", "nombre": "LA CUESTA (D. M.)" },
      { "codigo": "250504", "nombre": "LAS PLACETAS (D. M.)" },
      { "codigo": "250600", "nombre": "MUNICIPIO TAMBORIL" },
      { "codigo": "250601", "nombre": "TAMBORIL" },
      { "codigo": "250602", "nombre": "CANCA LA PIEDRA (D. M.)" },
      { "codigo": "250700", "nombre": "MUNICIPIO VILLA GONZÁLEZ" },
      { "codigo": "250701", "nombre": "VILLA GONZÁLEZ" },
      { "codigo": "250702", "nombre": "PALMAR ARRIBA (D. M.)" },
      { "codigo": "250703", "nombre": "EL LIMÓN (D. M.)" },
      { "codigo": "250800", "nombre": "MUNICIPIO PUÑAL" },
      { "codigo": "250801", "nombre": "PUÑAL" },
      { "codigo": "250802", "nombre": "GUAYABAL (D. M.)" },
      { "codigo": "250803", "nombre": "CANABACOA (D. M.)" },
      { "codigo": "250900", "nombre": "MUNICIPIO SABANA IGLESIA" },
      { "codigo": "250901", "nombre": "SABANA IGLESIA" },
      { "codigo": "251000", "nombre": "BAITOA" },
      { "codigo": "251001", "nombre": "BAITOA" }
    ]
  },
  {
    codigo: "260000", nombre: "SANTIAGO RODRÍGUEZ", municipios: [
      { "codigo": "260100", "nombre": "MUNICIPIO SAN IGNACIO DE SABANETA" },
      { "codigo": "260101", "nombre": "SAN IGNACIO DE SABANETA (D. M.)" },
      { "codigo": "260200", "nombre": "MUNICIPIO VILLA LOS ALMÁCIGOS" },
      { "codigo": "260201", "nombre": "VILLA LOS ALMÁCIGOS (D. M.)" },
      { "codigo": "260300", "nombre": "MUNICIPIO MONCIÓN" },
      { "codigo": "260301", "nombre": "MONCIÓN (D. M.)" }
    ]
  },
  {
    codigo: "270000", nombre: "VALVERDE", municipios: [
      { "codigo": "270100", "nombre": "MUNICIPIO MAO" },
      { "codigo": "270101", "nombre": "MAO (D. M.)" },
      { "codigo": "270102", "nombre": "AMINA (D. M.)" },
      { "codigo": "270103", "nombre": "JAIBÓN (PUEBLO NUEVO) (D. M.)" },
      { "codigo": "270104", "nombre": "GUATAPANAL (D. M.)" },
      { "codigo": "270200", "nombre": "MUNICIPIO ESPERANZA" },
      { "codigo": "270201", "nombre": "ESPERANZA" },
      { "codigo": "270202", "nombre": "MAIZAL (D. M.)" },
      { "codigo": "270203", "nombre": "JICOMÉ (D. M.)" },
      { "codigo": "270204", "nombre": "BOCA DE MAO (D. M.)" },
      { "codigo": "270205", "nombre": "PARADERO (D. M.)" },
      { "codigo": "270300", "nombre": "MUNICIPIO LAGUNA SALADA" },
      { "codigo": "270301", "nombre": "LAGUNA SALADA (D. M.)" },
      { "codigo": "270302", "nombre": "JAIBÓN (D. M.)" },
      { "codigo": "270303", "nombre": "LA CAYA (D. M.)" },
      { "codigo": "270304", "nombre": "CRUCE DE GUAYACANES (D. M.)" }
    ]
  },
  {
    codigo: "280000", nombre: "MONSEÑOR NOUEL", municipios: [
      { "codigo": "280100", "nombre": "MUNICIPIO BONAO" },
      { "codigo": "280101", "nombre": "BONAO (D. M.)" },
      { "codigo": "280102", "nombre": "SABANA DEL PUERTO (D. M.)" },
      { "codigo": "280103", "nombre": "JUMA BEJUCAL (D. M.)" },
      { "codigo": "280104", "nombre": "ARROYO TORO - MASIPEDRO (D. M.)" },
      { "codigo": "280105", "nombre": "JAYACO (D. M.)" },
      { "codigo": "280106", "nombre": "LA SALVIA - LOS QUEMADOS (D. M.)" },
      { "codigo": "280200", "nombre": "MUNICIPIO MAIMÓN" },
      { "codigo": "280201", "nombre": "MAIMÓN (D. M.)" },
      { "codigo": "280300", "nombre": "MUNICIPIO PIEDRA BLANCA" },
      { "codigo": "280301", "nombre": "PIEDRA BLANCA (D. M.)" },
      { "codigo": "280302", "nombre": "VILLA DE SONADOR (D. M.)" },
      { "codigo": "280303", "nombre": "JUAN ADRIÁN (D. M.)" }
    ]
  },
  {
    codigo: "290000", nombre: "MONTE PLATA", municipios: [
      { "codigo": "290100", "nombre": "MUNICIPIO MONTE PLATA" },
      { "codigo": "290101", "nombre": "MONTE PLATA (D. M.)" },
      { "codigo": "290102", "nombre": "DON JUAN (D. M.)" },
      { "codigo": "290103", "nombre": "CHIRINO (D. M.)" },
      { "codigo": "290104", "nombre": "BOYÁ (D. M.)" },
      { "codigo": "290200", "nombre": "MUNICIPIO BAYAGUANA" },
      { "codigo": "290201", "nombre": "BAYAGUANA (D. M.)" },
      { "codigo": "290300", "nombre": "MUNICIPIO SABANA GRANDE DE BOYÁ" },
      { "codigo": "290301", "nombre": "SABANA GRANDE DE BOYÁ (D. M.)" },
      { "codigo": "290302", "nombre": "GONZALO (D. M.)" },
      { "codigo": "290303", "nombre": "MAJAGUAL (D. M.)" },
      { "codigo": "290400", "nombre": "MUNICIPIO YAMASÁ" },
      { "codigo": "290402", "nombre": "LOS BOTADOS (D. M.)" },
      { "codigo": "290403", "nombre": "MAMÁ TINGÓ (D. M.)" },
      { "codigo": "290500", "nombre": "MUNICIPIO PERALVILLO" },
      { "codigo": "290501", "nombre": "PERALVILLO (D. M.)" }
    ]
  },
  {
    codigo: "300000", nombre: "HATO MAYOR", municipios: [
      { "codigo": "300100", "nombre": "MUNICIPIO HATO MAYOR" },
      { "codigo": "300101", "nombre": "HATO MAYOR (D. M.)" },
      { "codigo": "300102", "nombre": "YERBA BUENA (D. M.)" },
      { "codigo": "300103", "nombre": "MATA PALACIO (D. M.)" },
      { "codigo": "300104", "nombre": "GUAYABO DULCE (D. M.)" },
      { "codigo": "300200", "nombre": "MUNICIPIO SABANA DE LA MAR" },
      { "codigo": "300201", "nombre": "SABANA DE LA MAR (D. M.)" },
      { "codigo": "300202", "nombre": "ELUPINA CORDERO DE LAS CAÑITAS (D. M.)" },
      { "codigo": "300300", "nombre": "MUNICIPIO EL VALLE" },
      { "codigo": "300301", "nombre": "EL VALLE (D. M.)" }
    ]
  },
  {
    codigo: "310000", nombre: "SAN JOSÉ DE OCOA", municipios: [
      { "codigo": "310100", "nombre": "MUNICIPIO SAN JOSÉ DE OCOA" },
      { "codigo": "310101", "nombre": "SAN JOSÉ DE OCOA (D. M.)" },
      { "codigo": "310102", "nombre": "LA CIÉNAGA (D. M.)" },
      { "codigo": "310103", "nombre": "NIZAO - LAS AUYAMAS (D. M.)" },
      { "codigo": "310104", "nombre": "EL PINAR (D. M.)" },
      { "codigo": "310105", "nombre": "EL NARANJAL (D. M.)" },
      { "codigo": "310200", "nombre": "MUNICIPIO SABANA LARGA" },
      { "codigo": "310201", "nombre": "SABANA LARGA (D. M.)" },
      { "codigo": "310300", "nombre": "MUNICIPIO RANCHO ARRIBA" },
      { "codigo": "310301", "nombre": "RANCHO ARRIBA (D. M.)" }
    ]
  },
  {
    codigo: "320000", nombre: "SANTO DOMINGO", municipios: [
      { "codigo": "320100", "nombre": "MUNICIPIO SANTO DOMINGO ESTE" },
      { "codigo": "320101", "nombre": "SANTO DOMINGO ESTE (D. M.)" },
      { "codigo": "320102", "nombre": "SAN LUIS (D. M.)" },
      { "codigo": "320200", "nombre": "MUNICIPIO SANTO DOMINGO OESTE" },
      { "codigo": "320201", "nombre": "SANTO DOMINGO OESTE (D. M.)" },
      { "codigo": "320300", "nombre": "MUNICIPIO SANTO DOMINGO NORTE" },
      { "codigo": "320301", "nombre": "SANTO DOMINGO NORTE (D. M.)" },
      { "codigo": "320302", "nombre": "LA VICTORIA (D. M.)" },
      { "codigo": "320400", "nombre": "MUNICIPIO BOCA CHICA" },
      { "codigo": "320401", "nombre": "BOCA CHICA (D. M.)" },
      { "codigo": "320402", "nombre": "LA CALETA (D. M.)" },
      { "codigo": "320500", "nombre": "MUNICIPIO SAN ANTONIO DE GUERRA" },
      { "codigo": "320501", "nombre": "SAN ANTONIO DE GUERRA (D. M.)" },
      { "codigo": "320502", "nombre": "HATO VIEJO (D. M.)" },
      { "codigo": "320600", "nombre": "MUNICIPIO LOS ALCARRIZOS" },
      { "codigo": "320601", "nombre": "LOS ALCARRIZOS (D. M.)" },
      { "codigo": "320602", "nombre": "PALMAREJO-VILLA LINDA (D. M.)" },
      { "codigo": "320603", "nombre": "PANTOJA (D. M.)" },
      { "codigo": "320700", "nombre": "MUNICIPIO PEDRO BRAND" },
      { "codigo": "320701", "nombre": "PEDRO BRAND (D. M.)" },
      { "codigo": "320702", "nombre": "LA GUÁYIGA (D. M.)" },
      { "codigo": "320703", "nombre": "LA CUABA (D. M.)" }
    ]
  },
];

export const getMunicipios = (provinciaCodigo) => {
  const p = PROVINCIAS.find((x) => x.codigo === provinciaCodigo);
  return p ? p.municipios : [];
};


export const getComprobante = [
  { "codigo": "31", "nombre": "Credito Fiscal Electronico" },
  { "codigo": "32", "nombre": "Factura de Consumo Electronico" },
  { "codigo": "44", "nombre": "Regímenes Especiales Electronico (Carnet)" }
];
export const getTipoComprobante = [
  { "codigo": "NC", "nombre": "Facturacion No Configurado" },
  { "codigo": "e-cf", "nombre": "Factura Electronica" },
  { "codigo": "FACT", "nombre": "PreFacturación" },
];